<div class="threads mt-3 pt-2 pb-2" [ngClass]="(task.threads.length > 0 || threadInCreation) ? '' : 'border-0'">
    @for(thread of threads; track thread.id){
        <div class="media thread-node bg-transparent">
            @if(thread.moderationStatus !== 'thread_moderation_under_review'){
                <tm-thread-message class="d-flex w-100"
                                [threadAuthors]="$safeNavigationMigration(task?.threadAuthors)"
                                [thread]="thread"
                                [timelineItemId]="$safeNavigationMigration(task?.id)"
                                [disableActions]="false"
                                (onThreadDeleted)="deleteThread($event)"
                                (onThreadReported)="moderateThread($event)"
                                (onThreadEdited)="onEditedThread($event)"></tm-thread-message>

                <task-thread-reactions [task]="task"
                                       [thread]="thread"
                                        (onThreadReactionsUpdated)="onThreadReactionsUpdated($event)"></task-thread-reactions>
            
            }@else {
                <tm-thread-message-under-moderation [thread]="thread"></tm-thread-message-under-moderation>
            }
        </div>
    }
    <div class="pb-3">
        <tm-thread-input-area [thread]="newThread"
                                [userInfos]="userInfos"
                                [threadAuthors]="$safeNavigationMigration(task?.threadAuthors)"
                                (onThreadAdded)="onThreadAdded($event)"
                                (onCancelUpdates)="onCancel()"
                                [setFocus]="threadInCreation" #newThreadComponent></tm-thread-input-area>
    </div>
</div>